const MOKA_SERVICE_HOST = import.meta.env.VITE_MOKA_SERVICE_HOST;
const MOKA_GOAUTH_SERVICE = import.meta.env.VITE_MOKA_GOAUTH_SERVICE;
const GOID_SERVICE = import.meta.env.VITE_GOID_SERVICE;
const PUSHER_APP_KEY = import.meta.env.VITE_PUSHER_APP_KEY;
const RECEIPT_API = import.meta.env.VITE_RECEIPT_API;

export { MOKA_SERVICE_HOST, MOKA_GOAUTH_SERVICE, GOID_SERVICE, PUSHER_APP_KEY, RECEIPT_API };
